import { styles } from '@components/form'
import { Author } from '@services/api/authors'
import classNames from 'classnames'

interface AuthorFooter extends Author {
  className?: string
}

export const AuthorFooter = ({
  name,
  avatar,
  biography,
  className
}: AuthorFooter): JSX.Element => {
  return (
    <div
      className={classNames(
        className,
        styles.authorFooter,
        'mx-auto max-w-[816px] mt-4 mb-8'
      )}
    >
      <div className="flex items-center font-myriad md:gap-1 mt-4">
        <img
          src={avatar}
          alt={`Avatar de ${name}`}
          className="w-[97px] h-[97px] rounded-full object-cover"
        />

        <div className="ml-4">
          <p className="text-primaryVeryLightBlue text-lg font-bold tracking-normal mb-2 text-left">
            {name}
          </p>
          <p className="tracking-tight text-left">{biography}</p>
        </div>
      </div>
    </div>
  )
}
